import * as React from 'react';
import { IStringLocalizer } from '../../../utilities/IStringLocalizer';

interface ToxnotReactModalFooterProps {
    enabledCloseButton?: boolean; // default is true
    customCloseButtonName?: string;
    localizer: IStringLocalizer;
    onCancel?: () => void;
}

/**
 * Shared component for a react modals footer. Should only be used with
 * ToxnotReactModal. Will always render with a close button unless specifically
 * told not too.
 */
export class ToxnotReactModalFooter extends React.PureComponent<ToxnotReactModalFooterProps> {
    public render() {
        return (
            <div className="modal-footer">
                {(this.props.enabledCloseButton ?? true) && <button type="button" className="btn btn-default" data-dismiss="modal" onClick={this.props.onCancel}>{(this.props.customCloseButtonName ?? this.props.localizer.localizeString("Cancel"))}</button>}
                {this.props.children}
            </div>
        );
    }
}

/**
 * Shared component for a react modals body. Should only be used with
 * ToxnotReactModal
 */
export class ToxnotReactModalBody extends React.PureComponent {
    public render() {
        return (
            <div className="modal-body">
                {this.props.children}
            </div>
        );
    }
}

interface ToxnotReactModalProps {
    modalId: string;
    localizedTitle?: string;
    additionalClasses?: string;
    onClose?: () => void;
    customHeader?: JSX.Element;
}

/**
 * A shared component that will render a bootstrap 3 modal. Meant to be used
 * with ToxnotReactModalBody and ToxnotReactModalFooter. 
 * 
 * To use, just render in a react component and call the JQuery modal show/hide
 * to show and hide.
 */
export class ToxnotReactModal extends React.PureComponent<ToxnotReactModalProps> {
    public render() {
        return (
            <div id={this.props.modalId} className={`modal fade ${this.props.additionalClasses ?? ""}`} role = "dialog" >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            {this.props.customHeader ?
                                this.props.customHeader : 
                                <>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.props.onClose}><span aria-hidden="true">&times;</span></button>
                                    <h4 className="modal-title">{this.props.localizedTitle ?? ""}</h4>
                                </>
                            }
                        </div>
                        {this.props.children}
                    </div>
                </div>
            </div>  
        );
    }
}